import { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

type Props = {
  icon: LucideIcon;
  label?: string;
  title: string;
  children?: ReactNode;
  className?: string;
};

/**
 * Canonical "How It Works" step card — gradient-square icon, uppercase step label,
 * purple heading. Use for numbered process steps only; use FeatureCard for capability grids.
 */
export const StepCard = ({ icon: Icon, label, title, children, className }: Props) => (
  <div className={cn("text-left", className)}>
    <div
      className="w-16 h-16 rounded-2xl flex items-center justify-center mb-4"
      style={{ background: "linear-gradient(135deg, #7130A0, #ED1878)" }}
    >
      <Icon className="w-8 h-8 text-white" aria-hidden="true" />
    </div>
    {label && (
      <div className="font-carlito text-ch-fuchsia text-xs uppercase tracking-widest mb-2">
        {label}
      </div>
    )}
    <h3 className="font-heading text-ch-purple text-xl mb-2">{title}</h3>
    {children && (
      <p className="font-carlito text-gray-700 text-sm leading-relaxed">{children}</p>
    )}
  </div>
);

export default StepCard;